import { routes } from "@constants/routes";
import { cookieKeys, getCookie, useAuth, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { token } = useAuth({ userType: UserTypeEnum.ORG });
  const isHijacked = getCookie(cookieKeys.hijackedJobSeeker);

  if (!token && !isHijacked) {
    return <Navigate to={routes.auth.main} state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
};
export default ProtectedRoute;
